// const videoSource = [
//   {
//     src: 'https://media.vued.vanthink.cn/sparkle_your_name_am360p.mp4',
//     resolution: 360,
//   }, {
//     src: 'https://media.vued.vanthink.cn/sparkle_your_name_am720p.mp4',
//     resolution: 720,
//   }, {
//     src: 'https://media.vued.vanthink.cn/y2mate.com%20-%20sparkle_your_name_amv_K_7To_y9IAM_1080p.mp4',
//     resolution: 1080
//   }
// ]


const DATA = [
  {
  id: 'gdbzhhifhh',
  title: '燕窝生产流程',
  author: '',
  date: '2020',
  desc: '',
  link: 'https://www.youtube.com/watch?v=tr8JzTLlq30',
  cover: '/images/印尼燕窝/视频封面/燕窝生产流程.png',
  // cover2: 'https://img1.wxzxzj.com/vpc-example-cover-5cm-v.jpg',
  // cover3: 'https://img1.wxzxzj.com/vpc-example-cover-5cm-c.jpg',
  source: '/videos/燕窝-工厂视频/燕窝生产流程.mp4',
  duration: '00:06:28'
}, {
  id: 'hfkhzwgnwx',
  title: '工厂严格高安全规格加工',
  author: '',
  date: '2020',
  desc: "",
  link: 'https://www.bilibili.com/bangumi/play/ss2546/?from=search&seid=5227685957756304310',
  cover: '/images/印尼燕窝/视频封面/工厂严格高安全规格加工.png',
  // cover2: 'https://img1.wxzxzj.com/vpc-example-cover-the-garden-v.jpg',
  // cover3: 'https://img1.wxzxzj.com/vpc-example-cover-the-garden-c.jpg',
  source: '/videos/燕窝-工厂视频/工厂严格高安全规格加工.mp4',
  duration: '00:02:01'
},
{
  id: 'jiytmghmyo',
  title: '燕窝包装',
  author: '',
  date: '2020',
  desc: "",
  link: 'https://www.bilibili.com/bangumi/play/ss12044/?from=search&seid=9670386519186098373',
  cover: '/images/印尼燕窝/视频封面/燕窝包装.png',
  // cover2: 'https://img1.wxzxzj.com/vpc-example-cover-your-name-v.jpg',
  // cover3: 'https://img1.wxzxzj.com/vpc-example-cover-your-name-c.png',
  source: "/videos/燕窝-工厂视频/燕窝包装.mp4",
  duration: '00:00:26'
},

{
  id: 'szmnyobnap',
  title: '燕窝的来源',
  author: '',
  date: '2020',
  desc: "",
  link: 'https://www.bilibili.com/bangumi/play/ss12044/?from=search&seid=9670386519186098373',
  cover: '/images/印尼燕窝/视频封面/燕窝的来源.png',
  // cover2: 'https://img1.wxzxzj.com/vpc-example-cover-your-name-v.jpg',
  // cover3: 'https://img1.wxzxzj.com/vpc-example-cover-your-name-c.png',
  source: "/videos/燕窝-工厂视频/燕窝的来源.mp4",
  duration: '00:00:21'
},

// {
//   id: 'szmnyobnap',
//   title: 'Weathering with You',
//   author: 'Makoto Shinkai',
//   date: '2019',
//   desc: "High schooler Hodaka Morishima runs away from his island home, planning to move to Tokyo. When his ferry is hit by a freak rainstorm, he is saved by Keisuke Suga, who gives Hodaka his business card. In Tokyo, Hodaka struggles to find work; a teenage McDonald's employee, Hina, takes pity on him and gives him food. After a chance encounter with a mobster, Hodaka finds a gun in a trashcan. Suga hires him as his assistant at a small publishing company, where he meets Suga's niece Natsumi. They investigate urban legends relating to the unusually rainy weather in Tokyo; from a psychic, they hear the legend of a \"weather maiden\" who can control the weather.",
//   link: 'https://www.youtube.com/watch?v=ps8qwWG8Uio',
//   cover: 'https://img1.wxzxzj.com/vpc-example-cover-weathering.png',
//   cover2: 'https://img1.wxzxzj.com/vpc-example-cover-weathering-v.jpg',
//   cover3: 'https://img1.wxzxzj.com/vpc-example-cover-weathering-c.jpg',
//   source: 'https://media.vued.vanthink.cn/y2mate.com%20-%20Weathering%20With%20You%20%5BOfficial%20Subtitled%20Trailer,%20GKIDS%5D_Q6iK6DjV_iE_1080p.mp4',
//   duration: '01:51:00'
// },
// {
//   id: 'usgfiayjqx',
//   title: 'CJ7',
//   author: 'Stephen Chow',
//   date: '2008',
//   desc: "",
//   link: 'https://www.youtube.com/watch?v=bB7KvdTJCzE',
//   cover: 'https://img1.wxzxzj.com/vpc-example-cover-CJ7.png',
//   cover2: 'https://img1.wxzxzj.com/vpc-example-cover-CJ7-v.jpg',
//   cover3: 'https://img1.wxzxzj.com/vpc-example-cover-CJ7-c.jpg',
//   source: 'https://media.vued.vanthink.cn/CJ7%20-%20Trailer.mp4',
//   duration: '00:46:04'
// }
];

export default DATA;
